import { typedAction } from "../helpers";
import { ShowFolderDeleteDialog } from "../models/reduxModels";
import { SET_SHOW_FOLDER_DELETE_DIALOG } from "./actionTypes";

const initialState: ShowFolderDeleteDialog = { showFolderDeleteDialog: false };

export const setShowFolderDeleteDialog = (toggleReload: boolean) => {
  return typedAction(SET_SHOW_FOLDER_DELETE_DIALOG, toggleReload);
};

type ShowFolderDeleteDialogAction = ReturnType<typeof setShowFolderDeleteDialog>;

export function showFolderDeleteDialogReducer(
  state = initialState,
  action: ShowFolderDeleteDialogAction
): ShowFolderDeleteDialog {
  switch (action.type) {
    case SET_SHOW_FOLDER_DELETE_DIALOG:
      return { ...state, showFolderDeleteDialog: action.payload };
    default:
      return state;
  }
}
